import styled, { css } from 'styled-components';
import { Theme, baseContainer } from '@redsift/design-system';
import { TooltipPlacement } from '../tooltip';
import { StyledTooltipContentProps } from './types';

/**
 * Component style.
 */
export const StyledTooltipContent = styled.div<StyledTooltipContentProps>`
  ${baseContainer}
  ${({ $theme }) => css`
    color: var(--redsift-color-neutral-${$theme === Theme.dark ? 'white' : 'x-dark-grey'});
    background-color: var(--redsift-color-neutral-${$theme === Theme.dark ? 'black' : 'white'});
  `}

  align-items: center;
  border-radius: 4px;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2);
  display: flex;
  filter: drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12));
  font-family: var(--redsift-typography-tooltip-font-family);
  font-size: var(--redsift-typography-tooltip-font-size);
  font-weight: var(--redsift-typography-tooltip-font-weight);
  line-height: var(--redsift-typography-tooltip-line-height);
  max-width: calc(100vw - 48px);
  padding: 4px 8px;
  z-index: var(--redsift-layout-z-index-tooltip);

  .redsift-tooltip-content__arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-color: ${({ $theme }) =>
      $theme === Theme.dark ? css`var(--redsift-color-neutral-black)` : css`var(--redsift-color-neutral-white)`};
    border-style: solid;
  }

  ${({ $placement }) => {
    switch ($placement) {
      case TooltipPlacement['right-start']:
        return css`
          border-bottom-left-radius: 0;
        `;
      case TooltipPlacement['right-end']:
        return css`
          border-top-left-radius: 0;
        `;
      case TooltipPlacement['left-start']:
        return css`
          border-bottom-right-radius: 0;
        `;
      case TooltipPlacement['left-end']:
        return css`
          border-top-right-radius: 0;
        `;
      default:
        return css``;
    }
  }}

  ${({ $placement }) => {
    switch ($placement) {
      case TooltipPlacement.left:
      case TooltipPlacement['left-end']:
      case TooltipPlacement['left-start']:
        return css`
          .redsift-tooltip-content__arrow {
            border-width: 6px 0 6px 6px;
            border-top-color: transparent;
            border-right-color: transparent;
            border-bottom-color: transparent;
          }
        `;
      case TooltipPlacement.top:
      case TooltipPlacement['top-end']:
      case TooltipPlacement['top-start']:
        return css`
          .redsift-tooltip-content__arrow {
            border-width: 6px 6px 0;
            border-right-color: transparent;
            border-bottom-color: transparent;
            border-left-color: transparent;
          }
        `;
      case TooltipPlacement.right:
      case TooltipPlacement['right-end']:
      case TooltipPlacement['right-start']:
        return css`
          .redsift-tooltip-content__arrow {
            border-width: 6px 6px 6px 0;
            border-top-color: transparent;
            border-bottom-color: transparent;
            border-left-color: transparent;
          }
        `;
      case TooltipPlacement.bottom:
      case TooltipPlacement['bottom-end']:
      case TooltipPlacement['bottom-start']:
      default:
        return css`
          .redsift-tooltip-content__arrow {
            border-width: 0 6px 6px;
            border-top-color: transparent;
            border-right-color: transparent;
            border-left-color: transparent;
          }
        `;
    }
  }}
`;
